<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		// text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	// /deep/ td {
	// 	text-align: center;
	// }

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}

.el-dropdown {
	vertical-align: top;
}
.el-dropdown + .el-dropdown {
	margin-left: 15px;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
<template>
	<div>
		<titles titlename="课程申请管理" titlecontent="这里可以审核课程申请" :mbx="paths"></titles>

		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入用户名" v-model="input" clearable></el-input></div>
			</div>

			<div class="sclectlable">
				<div><el-input placeholder="请输入真实姓名" v-model="reaminput" clearable></el-input></div>
			</div>
			<div class="primarybtn"><el-button @click="getname()" type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" :resizable="false" width="55"></el-table-column>
							<el-table-column label="申请课程" :resizable="false" prop="CO_CoursesName">
								<template slot-scope="scope">
									<p :title="scope.row.CO_CoursesName" style="width: 100%;">{{ scope.row.CO_CoursesName }}</p>
								</template>
							</el-table-column>
							<el-table-column width="100" :resizable="false" label="申请人" prop="UI_UserName">
								<template slot-scope="scope">
									<p :title="scope.row.UI_UserName" style="width: 100%;">{{ scope.row.UI_UserName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="申请时间" width="200" :resizable="false" prop="re_time"></el-table-column>
							<el-table-column label="审核人" :resizable="false" width="80" prop="ReUi_UserName">
								<template slot-scope="scope">
									<p :title="scope.row.ReUi_UserName" style="width: 100%;">{{ scope.row.ReUi_UserName }}</p>
								</template>
							</el-table-column>
							<el-table-column label="审核时间" width="200" :resizable="false" prop="Reviewtime">
								<template slot-scope="scope">
									<p :style="{ color: !scope.row.Reviewtime ? 'red' : '#409eff' }">{{ scope.row.Reviewtime ? scope.row.Reviewtime : '当前课程暂未审核' }}</p>
								</template>
							</el-table-column>
							<el-table-column label="状态" :resizable="false" width="120">
								<template slot-scope="scope">
									<p>{{ scope.row.Re_status == 0 ? '未审核' : scope.row.Re_status == 1 ? '审核通过' : '审核失败' }}</p>
								</template>
							</el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="120">
								<template slot-scope="scope">
									<div style="width: 100%;">
										<el-dropdown @command="changecoure($event, scope.row)" v-if="scope.row.Re_status != 2">
											<el-button size="mini" style="background-color: #F39C12;" :style="{ background: scope.row.Re_status == 1 ? '#67C23A' : '#F39C12' }">
												<p>{{ scope.row.Re_status !== 1 ? '审核' : '审核成功' }}</p>
											</el-button>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item command="1" v-if="scope.row.Re_status != 1">通过</el-dropdown-item>
												<el-dropdown-item command="2" v-if="scope.row.Re_status != 1">驳回</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>

										<el-button v-if="scope.row.Re_status == 2" size="mini" style="background-color: #E74C3C;">已被驳回</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnun }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { changeGetListreview, changeAuditCousersReview } from '@/request/api/homesview/yunhomes/yunhom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/cours/courseapplication',
					name: '课程审核'
				}
			],
			tabsnum: 10,
			totalall: 10,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				UserName: '',
				RealName: ''
			},
			tabsnun: 1,
			tableData: [],
			reaminput: ''
		};
	},
	components: {
		titles
	},
	mounted() {
		this.gettableData();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		getname() {
			this.pagesobj.UserName = this.reaminput;
			this.pagesobj.RealName = this.input;

			this.gettableData();
		},
		indexMethod(index) {
			return index + 1;
		},
		changetablesize() {
			this.pagesobj.pageSize = this.tabsnun;
			this.gettableData();
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.gettableData();
		},
		gettableData() {
			changeGetListreview(this.pagesobj).then(res => {
				// console.log(res)
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;
			});
		},
		changecoure(val, itm) {
			// console.log(val, '更改指令事件', itm);

			let coures = {
				Re_Guid: itm.re_guid,
				Re_Status: val
			};
			changeAuditCousersReview(coures).then(res => {
				// console.log(res)
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.gettableData();
				}
			});
		}
	}
};
</script>
